export const SITE_URL = 'https://dicomity.com.ar';
export const SITE_NAME = 'DICOMITY';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/screenshots/dicomfiles/product.png`;

// Every key is prerendered to static HTML at build time (scripts/prerender.mjs).
export const SEO_PAGES = {
  '/': {
    title: 'DICOMITY | Interoperabilidad e integración de imágenes médicas DICOM',
    description:
      'Soluciones de interoperabilidad que integran imágenes médicas, sistemas clínicos y procesos digitales: automatización DICOM, integración con PACS y captura desde equipos médicos.',
  },
  '/products': {
    title: 'Productos DICOM: DICOMFiles y DICOMCapture | DICOMITY',
    description:
      'Conocé DICOMFiles y DICOMCapture: automatización del flujo DICOM, integración con PACS, worklist y captura desde equipos médicos para tu institución de salud.',
  },
  '/dicomfiles': {
    title: 'DICOMFiles: automatización del flujo DICOM e integración PACS | DICOMITY',
    description:
      'DICOMFiles automatiza el flujo DICOM 24/7: integración con PACS, gestión de worklist, procesamiento de PDFs y códigos QR, y menos trabajo manual y errores.',
  },
  '/dicomcapture': {
    title: 'DICOMCapture: captura de imágenes desde equipos médicos | DICOMITY',
    description:
      'DICOMCapture conecta la adquisición de imágenes con tu flujo clínico: captura desde equipos médicos, validación de calidad y envío ordenado a tus sistemas.',
  },
  '/documentation': {
    title: 'Documentación técnica | DICOMITY',
    description:
      'Documentación técnica de los productos DICOMITY: instalación, configuración e integración de DICOMFiles y DICOMCapture.',
  },
  '/contact': {
    title: 'Contacto | DICOMITY',
    description:
      'Contactá a DICOMITY para implementar soluciones de interoperabilidad e integración de imágenes médicas DICOM en tu institución.',
  },
};

export const normalizeSeoPath = (pathname) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, '') || '/' : pathname;

export const getSeoPage = (pathname) => {
  const path = normalizeSeoPath(pathname);
  return {
    ...(SEO_PAGES[path] ?? SEO_PAGES['/']),
    url: `${SITE_URL}${path}`,
  };
};
